import {
  ActiveProductsResponse,
  AllSubscriptionsResponse,
  CreateSubscriptionResponse,
} from 'types';

import { STXAxiosInstance } from '../Axios/STXAxiosInstance';

export const getAllActiveProducts = () => {
  return STXAxiosInstance.get<ActiveProductsResponse>('/products').then((data) => {
    return data.data.data;
  });
};

export const getAllSubscriptionOrders = (multisigId: string) => {
  return STXAxiosInstance.get<AllSubscriptionsResponse>(
    '/subscription-order/' + multisigId + '?page=0&limit=1000'
  ).then((data) => {
    return data.data.data;
  });
};

export const createSubscriptionOrder = (data: { multiSigId: string; subscriptionRate: string }) => {
  return STXAxiosInstance.post<CreateSubscriptionResponse>('/subscription-order', {
    ...data,
  }).then((data) => {
    return data.data.data;
  });
};
